<template>
  <div class="d-block px-2 py-3">
    <ModalDelete ref="ModalDelete" confirm-text="ya" @action="removeData">
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold">Batalkan Transaksi</span>
      </template>
      <template v-slot:body>
        <div class="text-center">Apakah Anda yakin ingin menghapus produk "<span class="text-capitalize" v-if="selectedItem">{{ selectedItem.product_name }}</span>"?</div>
      </template>
    </ModalDelete>

    <v-expansion-panels
      v-model="panel"
      id="filter-produkcard"
      tile
      accordion
      focusable
      class="accordion-filter d-none"
    >
      <v-expansion-panel>
        <v-expansion-panel-header
          class="text-uppercase font-weight-bold text-body-2 px-3 py-3 mt-5"
          >
          <div><v-icon>mdi-filter-outline</v-icon> Filter</div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="px-4 pt-4 pb-0 mt-2 border" outlined>
          <v-form>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                  v-model="productNameFilter.value"
                  outlined
                  small
                  dense
                  hide-details
                  class="searchInput"
                  placeholder="cari nama produk atau SKU"
                >
                  <div slot="append">
                    <v-btn
                      small
                      elevation="2"
                      color="success"
                    >
                      <v-icon center>
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                  </div>
                </v-text-field>
              </v-col>

              <!-- <v-col cols="6" class="py-0">
                <v-select
                  v-model="productCategoryFilter.value"
                  :items="category"
                  item-text="product_category_name"
                  item-value="product_category_id"
                  placeholder="Pilih Kategori"
                  outlined
                  multiple
                  dense
                ></v-select>
              </v-col> -->
            </v-row>

            <v-row>
              <v-col cols="6" class="py-0">
                <v-row class="align-center">
                  <v-col cols="3" class="py-0">
                    Stok
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productStockMinFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                  <v-col cols="1" class="py-0">
                    -
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productStockMaxFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="6" class="py-0">
                <v-row class="align-center">
                  <v-col cols="3" class="py-0">
                    Penjualan
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productSoldMinFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                  <v-col cols="1" class="py-0">
                    -
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productSoldMaxFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-right pb-0 pt-5 mt-3">
                <v-btn
                  color="success"
                  elevation="2"
                  dark
                  class="mr-3"
                  width="140"
                  @click="cari"
                >
                  <strong class="text-uppercase">Cari</strong>
                </v-btn>

                <v-btn
                  color="error"
                  elevation="2"
                  outlined
                  dark
                  width="140"
                  @click="resetFilter"
                >
                  <strong class="text-uppercase">Reset</strong>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row class="my-0 align-center">
      <v-col cols="12" sm="6">
        <div class="text-subtitle-2 font-weight-bold">
          {{product_by_type.title}}
          <v-chip
            small
            class="ma-2"
            :color="product_by_type.colorCount"
            outlined
          >
            {{ productList.pagination.total_data }}
          </v-chip>
        </div>
      </v-col>
      <v-col cols="12" sm="6" :class="(isMobile) ? 'text-left pt-0' : 'text-right'">
        <!-- <v-btn
          color="success"
          elevation="2"
          dark
          @click="addProduk()"
        >
          <v-icon color="white darken-1 mr-2">mdi-plus</v-icon>
          <strong class="text-capitalize"><small>Tambah Produk</small></strong>
        </v-btn> -->
      </v-col>
    </v-row>

    <v-layout v-resize="onResize" column>
      <v-data-table
        :server-items-length="productList.pagination.total_data"
        hide-default-footer
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="productList.lists"
        :expanded.sync="expanded"
        single-expand
        item-key="store_product_id"
        show-expand
        class="elevation-1 border"
        :class="{mobile: isMobile}"
        id="product-table"
      >
        <template v-slot:header.product_name="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>
        <template v-slot:header.product_weight="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>
        <template v-slot:header.store_product_product_price="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>
        <template v-slot:header.product_dropship_hd6_price="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>
        <template v-slot:header.store_product_stock_balance="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>

        <template v-slot:item.product_name="{ item }">
          <div class="d-flex" :class="(isMobile) ? 'flex-column align-start justify-start' : 'flex-row align-center'">
            <v-img :width="(isMobile) ? 120 : 80" :max-width="(isMobile) ? 80 : 50" class="mr-3 my-3" :src="item.store_product_product_image ? item.store_product_product_image : '/assets/product/default.png'"></v-img>
            <div class="font-weight-bold no-line green--text">{{ item.product_name }}</div>
          </div>
        </template>

        <template v-slot:item.store_product_product_price="{ item }">
          {{ item.store_product_product_price | toRupiah }}
        </template>

        <template v-slot:item.product_dropship_hd6_price="{ item }">
          <!-- {{ item.product_dropship_hd6_price | toRupiah }} -->
          {{ item.store_product_product_price | toRupiah }}
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-row>
              <v-col cols="12" class="text-right">
                <router-link :to="{name: 'seller-produk-ubah', params: {id:item.store_product_id}}">
                  <v-btn
                    small
                    color="grey darken-2"
                    elevation="1"
                    outlined
                    tile
                    dark
                    :class="(isMobile) ? 'v-btn--block white mb-2 py-4' : 'white mr-2'"
                  >
                    <span class="text-capitalize font-weight-medium black--text"><v-icon medium class="grey--text darken-1 font-weight-normal mr-2">mdi-pencil-box-outline</v-icon>Edit Produk</span>
                  </v-btn>
              </router-link>

                <v-btn
                  small
                  color="grey darken-2"
                  elevation="1"
                  outlined
                  tile
                  dark
                  :class="(isMobile) ? 'v-btn--block white mb-2 py-4' : 'white mr-2'"
                  v-if="false"
                >
                  <span class="text-capitalize font-weight-medium black--text"><v-icon small class="grey--text darken-1 font-weight-normal mr-2">mdi-content-copy</v-icon>Duplikat Produk</span>
                </v-btn>

                <v-btn
                  small
                  color="grey darken-2"
                  elevation="1"
                  outlined
                  tile
                  dark
                  :class="(isMobile) ? 'v-btn--block white mb-2 py-4' : 'white mr-2'"
                  @click="openReminderDialog(item)"
                  v-if="false"
                >
                  <span class="text-capitalize font-weight-medium black--text"><v-icon small class="grey--text darken-1 font-weight-normal mr-2">mdi-bell-ring-outline</v-icon>Pengingat Stok</span>
                </v-btn>

                <!-- <v-btn
                  small
                  color="error"
                  elevation="1"
                  outlined
                  tile
                  dark
                  :class="(isMobile) ? 'v-btn--block white py-4' : 'white'"
                  @click="hapus(item)"
                >
                  <span class="text-capitalize font-weight-medium"><v-icon medium class="error--text darken-1 font-weight-normal mr-2">mdi-delete-outline</v-icon>Hapus Produk</span>
                </v-btn> -->
              </v-col>
            </v-row>
          </td>
        </template>

        <template v-slot:no-data>
          <div class="d-flex flex-column align-center py-5 px-5">
            <v-img width="260" class="py-5 my-4" src="/assets/seller/belum-ada-barang.svg"></v-img>
            <div class="text-h6 black--text">Produk yang Anda cari tidak ditemukan</div>
            <!-- <p>Barang jualan kamu akan muncul di halaman ini. Ayo mulai berjualan di <strong class="green--text">HWI Ecommerce</strong> sekarang!</p> -->
          </div>
        </template>
      </v-data-table>
    </v-layout>

    <v-pagination v-if="productList.pagination.total_page > 1 && productList.lists.length > 0" @input="updatePage" v-model="page" :length="productList.pagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus py-2"></v-pagination>

    <v-dialog
      v-model="dialogReminderStock"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline text-capitalize green--text darken-4">
          Pengingat Stok
        </v-card-title>
        <v-card-text class="pb-0" v-if="selectedItem">
          <div class="text-center font-weight-bold my-5 grey lighten-3 px-3 py-3">
            <p class="mb-0">{{ selectedItem.nama }}</p>
          </div>
          <v-row class="d-flex justify-start align-start">
            <v-col cols="2">
              <v-switch
                v-model="selectedItem.reminder"
                @change="(selectedItem.reminder === 1) ? selectedItem.reminder = 0 : selectedItem.reminder = 1"
                class="mt-0"
                dense
              ></v-switch>
            </v-col>
            <v-col cols="10" class="pl-0">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Pengingat Stok</div>
              <div class="d-flex flex-row align-center">
                <span class="text-caption pr-4 col-8 px-0">Pengingat akan aktif jika Stok produk kurang dari</span>
                <v-text-field
                  v-model="selectedItem.minStock"
                  outlined
                  x-small
                  dense
                  hide-details
                  :disabled="(selectedItem.reminder === 1) ? false : true"
                  width="100px"
                ></v-text-field>
                <span class="col-2"></span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <v-btn
              color="green darken-1 white--text"
              @click="dialogReminderStock = false, selectedItem = null"
              class="my-2 px-5"
            >
              Simpan
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ModalDelete from '@/components/ModalDelete'

export default {
  components: {
    ModalDelete
  },

  data() {
    return {
      loading: false,
      page: 1,
      limit: 8,
      params: [],
      sort: {},
      sortBy: '',
      sortDir: '',

      panel: [0],

      productCategoryFilter: {
        value: '',
        comparison: '=',
        type: 'string',
        field: 'product_category_id',
      },
      productNameFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'product_name',
      },
      productStockMinFilter: {
        value: '',
        comparison: '>',
        type: 'numeric',
        field: 'store_stock_quantity',
      },
      productStockMaxFilter: {
        value: '',
        comparison: '<',
        type: 'numeric',
        field: 'store_stock_quantity',
      },
      productSoldMinFilter: {
        value: '',
        comparison: '>',
        type: 'numeric',
        field: 'product_sold_count',
      },
      productSoldMaxFilter: {
        value: '',
        comparison: '<',
        type: 'numeric',
        field: 'product_sold_count',
      },

      filter: {
        search: '',
        categoryId: null,
        minStock: 0,
        maxStock: 0,
        minSold: 0,
        maxSold: 0
      },
      selected: [],
      expanded: [],
      headers: [
        {
          text: 'Info Produk',
          align: 'start',
          sortable: false,
          value: 'product_name',
          width: '40%'
        },
        { text: 'Harga Jual', sortable: false, value: 'store_product_product_price' },
        { text: 'Berat (Gr)',sortable: false, value: 'product_weight', align: 'center' },
        // { text: 'Unit', value: 'product_unit', sortable: false, align: 'center' },
        // { text: 'Penjualan',sortable: false, value: 'store_product_buy', align: 'center' },
        { text: '', value: 'data-table-expand' }
      ],
      selectedItem: null,
      dialogReminderStock:false,
      isMobile: false,
    }
  },

  props:{
    type: String
  },

  computed: {
    ...mapState('productSeller', ['productList']),
    ...mapState('authSeller', ['isAuth', 'sellerData']),
    // ...mapState('category', ['category']),

    product_by_type() {
      let dataType = {
        title: 'Semua Produk',
        colorCount: 'green',
      }
      switch (this.type) {
        case 'all':
        dataType = {
          title: 'Semua Produk',
          colorCount: 'green',
        }
        break

        case 'live':
        dataType = {
          title: 'Produk Live',
          colorCount: 'green',
        }
        break

        case 'sold-out':
        dataType = {
          title: 'Produk Habis',
          colorCount: 'error',
        }
        break

        default:
        return {
          title: 'Semua Produk',
          colorCount: 'green',
        }
      }

      return dataType
    }
  },

  methods: {
    ...mapActions('productSeller', ['getStoreProduct']),

    setupHeaders() {
      const seller = this.sellerData
      if (seller.store_is_dropshipper == 'Ya') {
        if (seller.store_is_dropshipper == 'Ya' && seller.store_is_seller == 'Tidak') {
          this.headers = [
            {
              text: 'Info Produk',
              align: 'start',
              sortable: false,
              value: 'product_name',
              width: '40%'
            },
            { text: 'Berat (Gr)',sortable: false, value: 'product_weight', align: 'center' },
            { text: 'Harga Jual', sortable: false, value: 'store_product_product_price' },
            { text: '', value: 'data-table-expand' }
          ]
        } else {
          this.headers = [
            {
              text: 'Info Produk',
              align: 'start',
              sortable: false,
              value: 'product_name',
              width: '40%'
            },
            { text: 'Berat (Gr)',sortable: false, value: 'product_weight', align: 'center' },
            { text: 'Harga Jual', sortable: false, value: 'store_product_product_price' },
            { text: 'Stok', value: 'store_product_stock_balance', sortable: false, align: 'center' },
            { text: '', value: 'data-table-expand' }
          ]
        }
      } else if (seller.store_is_dropship == 'Ya') {
        if (seller.store_is_dropship == 'Ya' && seller.store_is_seller == 'Tidak') {
          this.headers = [
            {
              text: 'Info Produk',
              align: 'start',
              sortable: false,
              value: 'product_name',
              width: '40%'
            },
            { text: 'Berat (Gr)',sortable: false, value: 'product_weight', align: 'center' },
            { text: 'Harga Dropship', value: 'product_dropship_hd6_price', sortable: false, align: 'right' },
            { text: 'Stok', value: 'store_product_stock_balance', sortable: false, align: 'center' },
            { text: '', value: 'data-table-expand' }
          ]
        } else {
          this.headers = [
            {
              text: 'Info Produk',
              align: 'start',
              sortable: false,
              value: 'product_name',
              width: '40%'
            },
            { text: 'Berat (Gr)',sortable: false, value: 'product_weight', align: 'center' },
            { text: 'Harga Jual', sortable: false, value: 'store_product_product_price', align: 'right' },
            { text: 'Harga Dropship', value: 'product_dropship_hd6_price', sortable: false, align: 'right' },
            { text: 'Stok', value: 'store_product_stock_balance', sortable: false, align: 'center' },
            { text: '', value: 'data-table-expand' }
          ]
        }
      }
      
    },

    async ubahStatus(val, id, item) {
      await this.statusProduct({
        id: id,
        status: val,
      }).then(() => {
        this.getStoreProduct()
      }).catch(() => {
        if (item.product_is_active == 'active') {
          item.product_is_active = 'inactive'
        } else {
          item.product_is_active = 'active'
        }
      })
    },

    async getStoreProducts() {
      this.loading = await true
      switch (this.type) {
        case 'all':
        break;

        case 'live':
        this.params.push({
          value: 'active',
          comparison: '=',
          type: 'string',
          field: 'product_is_active',
        })
        break;

        case 'sold-out':
        this.params.push({
          value: '0',
          comparison: '=',
          type: 'numeric',
          field: 'store_stock_quantity',
        })
        break;
      }
      await this.getStoreProduct(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      )
      this.loading = false
    },

    cari() {
      this.params = []

      if (this.productNameFilter.value) this.params.push(this.productNameFilter)
      if (this.productCategoryFilter.value) this.params.push(this.productCategoryFilter)
      if (this.productStockMinFilter.value) this.params.push(this.productStockMinFilter)
      if (this.productStockMaxFilter.value) this.params.push(this.productStockMaxFilter)
      if (this.productSoldMinFilter.value) this.params.push(this.productSoldMinFilter)
      if (this.productSoldMaxFilter.value) this.params.push(this.productSoldMaxFilter)

      this.sortBy = this.sort.sortBy
      this.sortDir = this.sort.sortDir
      this.page = 1
      this.getStoreProduct()
    },

    resetFilter() {
      this.productNameFilter.value = ''
      this.productCategoryFilter.value = ''
      this.productStockMinFilter.value = ''
      this.productStockMaxFilter.value = ''
      this.productSoldMinFilter.value = ''
      this.productSoldMaxFilter.value = ''
      this.cari()
    },
    async hapus(item) {
      this.selectedItem = await item
      this.$refs.ModalDelete.modalShow()
    },

    removeData() {
      this.removeProduct({id: this.selectedItem.product_id}).then( () => {
        this.page = 1
        this.getStoreProduct()
      })
    },

    async openReminderDialog(item) {
      this.selectedItem = await item
      this.dialogReminderStock = true
    },

    addProduk() {
      this.$router.push({ path : '/seller/tambah-produk' })
    },
    updatePage(val) {
      this.page = val
      this.getStoreProducts()
    },

    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  async created() {
    this.loading = await true
    await this.$store.dispatch('setPageTitle', 'Produk Toko');
    this.setupHeaders()
    this.getStoreProducts()
  }
}
</script>